import {StarredAccountIdsDocument} from '@transactions/graphql';
import type {DataProxy} from '@apollo/client';

export const setStarredAccountIds = (store: DataProxy, ids: string[]) => {
  store.writeQuery({
    query: StarredAccountIdsDocument,
    data: {
      starredAccountIds: ids,
    },
  });
};
